import React, { useCallback } from 'react';
import { TStepRangesOption } from '../../../../api/endpoints/SubsetOption';
import Checkbox from '../../../Inputs/Checkbox/Checkbox';
import Index from '../../../Ui/CheckboxWrap';
import SelectAllControl from "../../SelectAllControl";

const StepRangesControl = (props: {
  spec: TStepRangesOption,
  values: Array<string>;
  onChange: (values: Array<string>) => void;
}) => {
  const { spec, values, onChange } = props;
  const options = spec.value.step;

  const onCheckboxChange = useCallback((value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  }, [onChange, values]);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />
      <Index>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option}
              value={option}
              checked={values.includes(option)}
              name="step-ranges"
              onChange={(checked) => onCheckboxChange(option, checked)}
            />)
        }
      </Index>
    </div>
  );
};

export default StepRangesControl;
